import React, { useContext } from 'react';
import { get } from 'lodash';
import { HistoricReviews } from 'src/components/index';
import { DashContext } from 'src/pagesDashboard/Dash/context/DashProvider';
import { UserProfileContext } from 'src/pagesDashboard/UserProfile/context/UserProfileProvider';
import { useUserFeedback } from 'src/containers/UserProfile/FeedbackDashboard/queries';
import appUtils from 'src/components/appUtils';

const HistoricReviewsForReviewer = ({ userId }) => {
  const loggedUserId = appUtils.getLoggedUserId();

  const isMyProfile = userId === loggedUserId;
  const {
    context,
    context: { range, currentPages, filters },
    updateContext
  } = useContext(isMyProfile ? DashContext : UserProfileContext);

  const setPage = (n) => {
    updateContext({
      currentPages: {
        ...context.currentPages,
        actHistoricReviews: n
      }
    });
  };

  const queryFilters = {
    pages: {
      page: currentPages.actHistoricReviews,
      pageSize: 10
    },
    filters: {
      ...filters,
      reviewerIds: [userId],
      includeEmptyComments: true
    },
    range
  };

  const {
    data: { userFeedbacks, pagination },
    isFetching: isFetchingFeedbacks
  } = useUserFeedback(null, queryFilters);

  const isFetching = isFetchingFeedbacks;

  return (
    <HistoricReviews
      showVisibleTooltip
      emptyPlaceholder='No reviews given'
      reviews={userFeedbacks ?? []}
      isLoading={isFetching}
      userId={userId}
      showRequestReview={false}
      pagination={{
        totalPages: get(pagination, 'pages', 0),
        currentPage: currentPages.actHistoricReviews,
        selectPage: setPage
      }}
    />
  );
};

export default HistoricReviewsForReviewer;
